import React from 'react';
import PropTypes from 'prop-types';
import Button from 'react-bootstrap/Button';
import { getConfigurationValue } from 'dmpconnectjsapp-base/helpers/accessors';
import { connect } from 'react-redux';
import Alert from 'react-bootstrap/Alert';
import env from '../../envVariables';

const ESLoginOpenIdConnect = ({ userManager, loginCheckValues, forceLoginCheck }) => {
  const signin = () => {
    userManager.signin();
  };

  if (forceLoginCheck) {
    const requiredValues = (env.REACT_APP_ES_LOGIN_CHECK_REQUIRED_VALUES || 'name,given,rpps').split(',');
    const loginCheckOK = loginCheckValues && requiredValues.every(val => val in loginCheckValues);
    if (!loginCheckOK) {
      return (
        <Alert variant="danger">
          Veuillez fournir les informations nécessaires à la vérification de l&apos;identité de l&apos;utilisateur
        </Alert>
      );
    }
  }
  return <Button block variant="primary" onClick={() => signin()}>Connexion OpenID</Button>;
};

ESLoginOpenIdConnect.propTypes = {
  userManager: PropTypes.object.isRequired,
  loginCheckValues: PropTypes.object,
  forceLoginCheck: PropTypes.bool,
};
ESLoginOpenIdConnect.defaultProps = {
  loginCheckValues: null,
  forceLoginCheck: false,
};


function mapStateToProps(state) {
  const {
    dmpConnectPersistedAppConfiguration,
  } = state;

  return {
    loginCheckValues: getConfigurationValue('logincheck', dmpConnectPersistedAppConfiguration),
    forceLoginCheck: getConfigurationValue('forceLoginCheck', dmpConnectPersistedAppConfiguration),
  };
}

export default connect(mapStateToProps)(ESLoginOpenIdConnect);
